import React, { ReactNode } from "react";
import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Box, Center, Spinner, Flex, Text,} from "@chakra-ui/react";
import MyDiv from "./customTable.style";
 
interface ColumnProps<T> {
  field?: keyof T | string;
  header?: ReactNode;
  body?: (rowData: T, index: number) => ReactNode;
}
 
export function Column<T>(_props: ColumnProps<T>) {
  return null;
}
 
interface CustomTableProps<T> {
  value: T[];
  children: React.ReactNode;
  headerColor?: string;
  borderColor?: string;
  loading?: boolean;
  emptyMessage?: string; 
}
 
export function CustomTable<T>({
  value,
  children,
  headerColor = "Black",
  loading,
  emptyMessage,
}: CustomTableProps<T>) {
  const columns = React.Children.toArray(children)
    .filter((child): child is React.ReactElement<ColumnProps<T>> => {
      return React.isValidElement(child) && child.type === Column;
    })
    .map((col) => col.props);

  return (
    <MyDiv>
      <Box position="relative" minH="300px">
        {loading ? (
          <Center position="absolute" top={0} left={0} right={0} bottom={0}>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="#006838"
              size="xl"
            />
          </Center>
        ) : value.length > 0 ? (
          <TableContainer mt={4} borderRadius="md" boxShadow="sm" bg="#fff">
            <Table variant="striped" size="sm">
              <Thead className='table_header font-poppins text_medium text_sm'>
                <Tr className="font-poppins text_regular text_md">
                  {columns.map((col, i) => (
                    <Th key={i} color={headerColor} fontWeight="semibold">
                      {col.header}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody >
                {value.map((row, rowIndex) => (
                  <Tr key={rowIndex}>
                    {columns.map((col, colIndex) => (
                      <Td key={colIndex}  className="font-poppins text_regular text_sm">
                        {col.body
                          ? col.body(row, rowIndex)
                          : (row as any)[col.field as string]}
                      </Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        ) : (
          <Flex justify="center" align="center" height="400px" color="gray.500">
            <Text className="font-poppins text_regular text_md">
              {emptyMessage || "No data available"}
            </Text>
          </Flex>
        )}
      </Box>
    </MyDiv>
  );
}

export default CustomTable;